export const ConfirmationProperties = {
  calendarClock: '../../../../assets//icons/shipment-card/calendar-clock.svg',
  mapLocation: '../../../../assets/icons/shipment-card/map-location.svg',
  moneyUp: '../../../../assets/money-up.svg',
  originDestination: '../../../../assets/origin-destination-icon-modern.svg',
  palletGear: '../../../../assets/icons/shipment-card/pallet-gear.svg',
  truckGear: '../../../../assets/icons/shipment-card/truck-gear.svg',
};
